import { batch } from 'react-redux';
import { httpPost, httpDownload, httpGet, httpPostFile } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import {
    getPlanCatalogue,
    setPlanCatalogueError,
    setPlanCatalogueColSearchStr,
    sortPlanCatalogueItems,
    setPlanCataloguePageSize,
    setDefaultPlanCatalogue,
    applyPlanCatalogueFilter,
    setPlanCatalogueFilter,
    getPlanCatalogueComments,
    getActivePlanVendors,
    getPlanRateStatus,
    getCircuitTypes,
    planCatalogueModel,
    planComponentModel,
    addPlanComponentDetails,
    getFinancePlanComponent,
    deletePlanComponent,
    updatePlanComponent,
    fetchPlanDetails,
    resetPlanComponent,
    setActiveVendorsLoading,
    setCircuitTypesLoading,
    resetPlanCatalogueComments,
    insertToPlanCatalogueComments
} from "../../../constants/model-reducers/external/finance/plan-catalogue.settings";
import { convertToFormatLocalDate, getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';
import { actions } from 'react-redux-form';

const defaultState = () => ({
    isPlanCatalogueLoaded: false,
    isPlanCatalogueError: false,
    planCatalogueItems: DEFAULT_TABLE_RESULT_MODEL,
    planCatalogueColSort: '',
    planCatalogueIsSortedAsc: false,
    planCatalogueTableFilterList: [],
    planCatalogueTableFilterApply: false,
    activePlanVendors: [],
    planRateStatus: [],
    planCircuitTypes: [],
    isLoaded: true,
    isLoadedInError: false,
    requiredPlanComponent: true,
    planVendorsLoaded: false,
    planCatalogueComments:[],
    planComponents: {
        dataTable: [],
    },
    planExist: false
});

const initialState = defaultState();

export const planCatalogueDetailsInitialState = planCatalogueModel;
export const planComponentInitialState = planComponentModel;

export const planCatalogueActions = {
    getPlanDetailsForm: (planDetailsId) => async (dispatch) => {
        var result = await httpGet(`external/finance/getPlanDetails/${planDetailsId ?? 0}`);
    
        if (result != null){
            batch(() => {
                dispatch(actions.load('planCatalogueDetailsForm.planId', result.planDetails.PlanId));
                dispatch(actions.load('planCatalogueDetailsForm.planName', result.planDetails.PlanName));
                dispatch(actions.load('planCatalogueDetailsForm.vendorDetailId', result.planDetails.VendorId));
                dispatch(actions.load('planCatalogueDetailsForm.vendorName', result.planDetails.VendorName));
                dispatch(actions.load('planCatalogueDetailsForm.circuitTypeId', result.planDetails.CircuitTypeId));
                dispatch(actions.load('planCatalogueDetailsForm.circuitTypeName', result.planDetails.CircuitType));
                dispatch(actions.load('planCatalogueDetailsForm.rateStatusId', result.planDetails.StatusId));
                dispatch(actions.load('planCatalogueDetailsForm.status', result.planDetails.Status));
                dispatch(actions.load('planCatalogueDetailsForm.currencyId', result.planDetails.CurrencyId));
                dispatch(actions.load('planCatalogueDetailsForm.currency', result.planDetails.Currency));
                dispatch(actions.load('planCatalogueDetailsForm.description', result.planDetails.Description));
            })
        }
        dispatch({
            type: fetchPlanDetails,
            data: false
        });
    
    },

    setDefaultPlanCatalogue: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultPlanCatalogue,
            planCatalogueItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getPlanCatalogue: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().planCatalogue.planCatalogueItems;
        const { planCatalogueIsSortedAsc, planCatalogueColSort, planCatalogueTableFilterList, planCatalogueTableFilterApply } = state().planCatalogue;

        var userId = sessionStorage.getItem('UserID');
        const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: planCatalogueColSort,
                IsSortAscending: planCatalogueIsSortedAsc,
                TableFilterList: planCatalogueTableFilterList,
                ApplyFilter: planCatalogueTableFilterApply,
            };
            var planCatalogueItems = await httpPost('external/finance/getPlanCatalogueItems', data);
            dispatch({
                type: getPlanCatalogue,
                planCatalogueItems: Object.keys(planCatalogueItems).length > 0 ? planCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                isPlanCatalogueLoaded: true,
                isPlanCatalogueError: false
            });
        }
        catch (e) {
            dispatch({
                type: setPlanCatalogueError,
                isPlanCatalogueError: true,
                isPlanCatalogueLoaded: false
            });
        }
    },

    getPlanCatalogueComments: (planID, pageIndex = 1, pageSize = 5, bypassPagination = true) => async (dispatch, state) => {
    
        const existingComments = state().planCatalogue?.planCatalogueComments || [];
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;
        const url = `external/finance/getPlanCatalogueComments/${pageIndex}/${pageSize}?catalogueID=${planID}`  
        + (lastCommentId ? `&lastCommentId=${lastCommentId}` : "");

        var res = await httpGet(url);

        // const newComments = res.catalogueComments.filter(
        //     c => !planCatalogueComments.some(x => x.CommentID === c.CommentID)
        // );

        if (res != null) {
            dispatch({
                type: getPlanCatalogueComments,
                planCatalogueComments: res.catalogueComments,
                isPlanCatalogueLoaded: true,
                isPlanCatalogueError: false,
                hasMoreData: res.hasMoreData,
                pageIndex: pageIndex,
            });
        } else {
            dispatch({
                type: setPlanCatalogueError,
                isPlanCatalogueError: true,
                isPlanCatalogueLoaded: false
            });
        }
    },

    resetPlanCatalogueComments: () => (dispatch) => {
            dispatch({
                type: resetPlanCatalogueComments,
            })
    },

    postPlanCatalogueComments: (planID, filename, fileData, comment) => async (dispatch, state) => {
        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("planID", planID);
        
        var res = await httpPostFile('external/finance/setPlanCatalogueComments/', formData);

        if (res != null) {

            dispatch({
                type: insertToPlanCatalogueComments,
                planCatalogueComments: [res?.planCatalogueCommentsList[0]],
                isPlanCatalogueLoaded: true,
                isPlanCatalogueError: false
            });
        } else {
            dispatch({
                type: setPlanCatalogueError,
                isPlanCatalogueError: true,
                isPlanCatalogueLoaded: false
            });
        }
    },

    deletePlanCatalogueComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('external/finance/planCatalogueDeleteComment/' + commentId + '/' + userId);

        if (res == null) {
            dispatch({
                type: setPlanCatalogueError,
                isPlanCatalogueError: true,
                isPlanCatalogueLoaded: false
            });
        }
    },

    setPlanCatalogueColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { planCatalogueItems } = state().planCatalogue;

        var planCatalogueItemsUpd = {
            ...planCatalogueItems,
            "Headers": {
                ...planCatalogueItems.Headers,
                [key]: {
                    ...planCatalogueItems.Headers[key],
                    searchString: val
                }
            }
        }
        dispatch({
            type: setPlanCatalogueColSearchStr,
            data: planCatalogueItemsUpd,
            isPlanCatalogueError: false,
            isPlanCatalogueLoaded: true
        });
    },

    resizePlanCataloguePage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setPlanCataloguePageSize,
            pageSize: parseInt(pageSize),
        });
    },
    sortPlanCatalogueItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().planCatalogue.planCatalogueItems.Pagination;
        const { planCatalogueItems, planCatalogueTableFilterList, planCatalogueTableFilterApply } = state().planCatalogue;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: planCatalogueItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...planCatalogueItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: planCatalogueTableFilterList,
            ApplyFilter: planCatalogueTableFilterApply,
        };

        var resPlanCatalogueItems = await httpPost('external/finance/getPlanCatalogueItems', data);

        if (resPlanCatalogueItems.ok === false) {
            dispatch({
                type: setPlanCatalogueError,
                isPlanCatalogueError: true,
                isPlanCatalogueLoaded: false
            });
        } else {
            dispatch({
                type: sortPlanCatalogueItems,
                planCatalogueItems: Object.keys(resPlanCatalogueItems).length > 0 ? resPlanCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                planCatalogueColSort: columnClicked,
                planCatalogueIsSortedAsc: isSortedAsc,
                isPlanCatalogueLoaded: true
            });
        }
    },
    addPlanCatalogueFilter: (tableFilter) => (dispatch, state) => {
        const { planCatalogueTableFilterList } = state().planCatalogue;
        var filterList = [...planCatalogueTableFilterList, tableFilter];

        dispatch({
            type: setPlanCatalogueFilter,
            filterList: filterList
        })
    },
    removePlanCatalogueFilter: (removeIndex) => (dispatch, state) => {
        const { planCatalogueTableFilterList } = state().planCatalogue;

        var filterList = planCatalogueTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setPlanCatalogueFilter,
            filterList: filterList
        })
    },
    applyPlanCatalogueFilter: (isApply) => (dispatch, state) => {
        const { planCatalogueTableFilterList } = state().planCatalogue;

        dispatch({
            type: applyPlanCatalogueFilter,
            applyFilter: isApply,
            filterList: isApply ? planCatalogueTableFilterList : []
        });
    },
    saveRateCatalogueCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().planCatalogue.planCatalogueItems;
        const { planCatalogueIsSortedAsc, planCatalogueColSort } = state().planCatalogue;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.PlanCatalogueFinanceManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/finance/savePlanCatalogueCustomizeColumns', customizeFormData)
            dispatch({
                type: setPlanCatalogueError,
                isPlanCatalogueError: true,
                isPlanCatalogueLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: planCatalogueColSort,
                IsSortAscending: planCatalogueIsSortedAsc,
            };

            var planCatalogueItems = await httpPost('external/finance/getPlanCatalogueItems', data);

            dispatch({
                type: getPlanCatalogue,
                planCatalogueItems: Object.keys(planCatalogueItems).length > 0 ? planCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                isPlanCatalogueLoaded: true,
                isPlanCatalogueError: false
            });
        }
        catch (e) {
            dispatch({
                type: setPlanCatalogueError,
                isPlanCatalogueError: true,
                isPlanCatalogueLoaded: false
            });
        }
    },
    extractPlanCatalogue: () => async (dispatch, state) => {
        const { Headers } = state().planCatalogue.planCatalogueItems;
        const { planCatalogueColSort, planCatalogueIsSortedAsc, planCatalogueTableFilterApply, planCatalogueTableFilterList } = state().planCatalogue;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filename = `ATEM ${dealName} Plan Extract - ${formattedTimeZoneDate}`;
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: planCatalogueColSort,
            IsSortAscending: planCatalogueIsSortedAsc,
            FileName: filename,
            TableFilterList: planCatalogueTableFilterList,
            ApplyFilter: planCatalogueTableFilterApply,
        };

        httpDownload('external/finance/getAllPlanCatalogueExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    getActivePlanVendors: (page=1, searchString='') => async (dispatch, getState) => {

        if (getState().planVendorsLoaded) return;  

        const pageSize = 15;

        dispatch({ 
            type: setActiveVendorsLoading,
            planVendorsLoaded: false 
        });

        var url = `external/finance/fetchVendors/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getActivePlanVendors,
                activePlanVendors: res?.vendors?.length > 0 ? res?.vendors : [],
                hasMoreData: res.hasMoreData,
                planVendorsLoaded: true,
                planVendorsError: false,
                page: page
            });
        } else {
            dispatch({
                type: setPlanCatalogueError,
                planVendorsLoaded: false,
                planVendorsError: true
            });
        }
    },

     getSelectedVendor: (vendorDetailId) => async (dispatch) => {
        var res = await httpGet('external/finance/getSelectedVendor' + '/' + vendorDetailId);
        return res;
    },
    
    getSelectedServiceType: (serviceTypeID) => async (dispatch) => {
        var res = await httpGet('external/finance/getSelectedServiceType' + '/' + serviceTypeID);
        return res;
    },

    getPlanRateStatus: () => async (dispatch) => {
        var res = await httpGet('external/finance/getPlanRateStatus')

        if (res != null) {
            dispatch({
                type: getPlanRateStatus,
                planRateStatus: res,
                isLoaded: true,
                isLoadedInError: false
            });
        } else {
            dispatch({
                type: setPlanCatalogueError,
                isLoaded: false,
                isLoadedInError: true
            });
        }
    },
    getCircuitTypes: (page =1, searchString) => async (dispatch) => {

        const pageSize = 15;
        
        dispatch({ 
            type: setCircuitTypesLoading,
            planVendorsLoaded: false 
        });

        var url = `external/finance/getServiceTypesList/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }

        var res = await httpGet(url)

        if (res != null) {
            dispatch({
                type: getCircuitTypes,
                planCircuitTypes: res?.serviceTypes?.length > 0 ? res?.serviceTypes : [],
                hasMoreData: res.hasMoreData,
                page: page,
                isLoaded: true,
                isLoadedInError: false
            });
        } else {
            dispatch({
                type: setPlanCatalogueError,
                isLoaded: false,
                isLoadedInError: true
            });
        }
    },
    savePlanCatalogue: (planID, validate) => async (dispatch, state) => {
        const { planId, planName, vendorDetailId, circuitTypeId, rateStatusId, description, currency } = state().form.planCatalogueDetailsForm;
        const { dataTable } = state().planCatalogue.planComponents;

        var financePlanComponents = dataTable.length > 0 ? dataTable[0].dataItem : [];


        try {
            var detailsForm = {
              
                 PlanName: planName
                , VendorDetailId: vendorDetailId
                , CircuitTypeId: circuitTypeId
                , RateStatusId: parseInt(rateStatusId)
                , Description: description
                , Currency: currency
            };

            var formData = {
                ...detailsForm,
                PlanComponent: financePlanComponents
            };

            var result = await httpPost(`external/finance/savePlanRate/${planId}/${validate}` , formData);

            dispatch(actions.resetErrors('planCatalogueDetailsForm'))

            if (result.isExist) {
                dispatch(actions.setErrors("planCatalogueDetailsForm.planName", true))
            }
        }
        catch (e) {
            return e
        }

        return result;
    },
    selectVendorId: (vendorId) => async (dispatch, state) => {
        const { activePlanVendors } = state().planCatalogue;

        var newPlanVendor = activePlanVendors.find(c => c.Key == vendorId);

        dispatch(actions.change(vendorId));

        getSelectedVendorCurrency(dispatch,vendorId);

        if (newPlanVendor) {
            dispatch(actions.change(`planCatalogueDetailsForm.vendorDetailId`, vendorId))
            dispatch(actions.change(`planCatalogueDetailsForm.vendorName`, newPlanVendor.VendorName));
            dispatch(actions.change(`planCatalogueDetailsForm.currency`, newPlanVendor.CurrencyName));
        }
        else {
            dispatch(actions.reset(`planCatalogueDetailsForm.vendorDetailId`))
            dispatch(actions.reset(`planCatalogueDetailsForm.vendorName`));
            dispatch(actions.reset(`planCatalogueDetailsForm.currency`));
        }
    },
    selectPlanCircuitTypeId: (key) => async (dispatch, state) => {
        const { planCircuitTypes } = state().planCatalogue;

        var selectCircuitTypeId = planCircuitTypes.find(k => k.Key)

        dispatch(actions.change(key));

        if (selectCircuitTypeId) {
            dispatch(actions.change(`planCatalogueDetailsForm.circuitTypeId`, key))
        }
        else {
            dispatch(actions.reset(`planCatalogueDetailsForm.circuitTypeId`))
        }
    },
    addPlanComponentDetails: () => async (dispatch, state) => {
        const { planComponentId, componentName, componentDetails, componentCost, planId } = state().form.planComponentForm;
        const { dataTable } = state().planCatalogue.planComponents;

        var dataItem = dataTable[0].dataItem
        var HeaderItem = dataTable[0].HeaderItem

        var newPlanComponents = [
            ...dataItem,
            {
                PlanId: planId
                , PlanComponentId: planComponentId
                , ComponentName: componentName
                , ComponentDetails: componentDetails
                , ComponentCost: componentCost == null ? 0 : parseFloat(componentCost)
            }
        ];

        var newDataTable = [{
            dataItem: newPlanComponents,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: addPlanComponentDetails,
            dataTable: newDataTable,
        })

        dispatch(actions.reset('planComponentForm'));
    },
    getFinancePlanComponent: (planId) => async (dispatch, state) => {
        var financePlanComponent = await httpGet('external/finance/getFinancePlanComponent?planId=' + planId);

        if (financePlanComponent != null) {
            dispatch({
                type: getFinancePlanComponent,
                planComponents: financePlanComponent,
                isLoaded: true,
                isLoadedInError: false
            });
        } else {
            dispatch({
                type: getFinancePlanComponent,
                isLoaded: false,
                isLoadedInError: true
            });
        }
    },
    deletePlanComponent: (index) => (dispatch, state) => {
        const { dataTable } = state().planCatalogue.planComponents;

        var dataItem = dataTable[0].dataItem
        var HeaderItem = dataTable[0].HeaderItem

        var newDataItem = [...dataItem]
        newDataItem.splice(index, 1)

        var newPlanList = newDataItem;

        var newDataTable = [{
            dataItem: newPlanList,
            HeaderItem: HeaderItem,
        }]

        dispatch({
            type: deletePlanComponent,
            dataTable: newDataTable,
        });
    },
    updatePlanComponent: (indexItem) => async (dispatch, state) => {
        const { dataTable } = state().planCatalogue.planComponents;
        const { ComponentName, ComponentDetails, ComponentCost } = state().form.planComponentForm;
        const currentPlanComponentId = dataTable[0].dataItem[indexItem].PlanComponentId;
        const currentPlanId = dataTable[0].dataItem[indexItem].PlanId;

        if (dataTable.length > 0) {

            var dataItem = dataTable[0].dataItem
            var HeaderItem = dataTable[0].HeaderItem


            dataItem[indexItem] = {
                ComponentName: ComponentName,
                ComponentDetails: ComponentDetails,
                ComponentCost: ComponentCost,
                PlanComponentId: currentPlanComponentId ? currentPlanComponentId : 0,
                PlanId: currentPlanId ? currentPlanId : 0
            }

            var newPlanList = [...dataItem]

            var newDataTable = [{
                dataItem: newPlanList,
                HeaderItem: HeaderItem,
            }]

            dispatch({
                type: updatePlanComponent,
                planExist: false,
                dataTable: newDataTable
            })
        }
    },
    resetFinancePlanForm: () => (dispatch) => {
        dispatch(actions.reset('planCatalogueDetailsForm'))
        dispatch({
            type: resetPlanComponent,
            dataTable: []
        });
    },
    resetFinancePlanComponent: () => (dispatch) => {
        dispatch(actions.reset('planComponentForm'));
    },
    setPlanComponentError: () => (dispatch) => {
        dispatch(actions.setErrors("planComponentForm.componentName", true))
        dispatch(actions.setErrors("planComponentForm.componentDetails", true))
        dispatch(actions.setErrors("planComponentForm.componentCost", true))
    }
}

async function getSelectedVendorCurrency(dispatch, vendorDetailId) {
    var res = await httpGet('external/finance/getSelectedVendorCurrency' + '/' + vendorDetailId);

    if (res != null) {
        dispatch(actions.change(`planCatalogueDetailsForm.currency`, res));
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getPlanCatalogue:
            return {
                ...state,
                planCatalogueItems: action.planCatalogueItems,
                isPlanCatalogueLoaded: action.isPlanCatalogueLoaded,
                isPlanCatalogueError: action.isPlanCatalogueError
            };
        case setPlanCatalogueError:
            return {
                ...state,
                isPlanCatalogueError: action.isPlanCatalogueError,
                isPlanCatalogueLoaded: action.isPlanCatalogueLoaded
            }
        case setPlanCatalogueColSearchStr:
            return {
                ...state,
                planCatalogueItems: action.data,
                isPlanCatalogueLoaded: action.isPlanCatalogueLoaded,
                isPlanCatalogueError: action.isPlanCatalogueError
            }
        case sortPlanCatalogueItems:
            return {
                ...state,
                planCatalogueItems: action.planCatalogueItems,
                planCatalogueColSort: action.planCatalogueColSort,
                planCatalogueIsSortedAsc: action.planCatalogueIsSortedAsc,
                isPlanCatalogueLoaded: action.isPlanCatalogueLoaded
            }
        case setPlanCataloguePageSize:
            return {
                ...state,
                planCatalogueItems: {
                    ...state.planCatalogueItems,
                    Pagination: {
                        ...state.planCatalogueItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setPlanCatalogueFilter:
            return {
                ...state,
                planCatalogueTableFilterList: action.filterList,
            };
        case applyPlanCatalogueFilter:
            return {
                ...state,
                planCatalogueTableFilterApply: action.applyFilter,
                planCatalogueTableFilterList: action.filterList
            };
        case getPlanCatalogueComments:
            return {
                ...state,
                planCatalogueComments: action.PageIndex === 1 ? action.planCatalogueComments : [...state.planCatalogueComments, ...action.planCatalogueComments],
                hasMoreComments: action.hasMoreData,
                pageIndex: action.pageIndex
        };

        case resetPlanCatalogueComments:
            return {
                ...state,
                planCatalogueComments: [],
                hasMoreComments: false,
                pageIndex: 1
        }

        case insertToPlanCatalogueComments: {
            const combinedComments = [
                ...action.planCatalogueComments,
                ...state.planCatalogueComments
            ];
            const currentVisibleCount = state.planCatalogueComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;
            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }

            return {
                ...state,
                planCatalogueComments: combinedComments.length === 1 ? action.planCatalogueComments : updatedComments,
                hasMoreComments: hasMore,
            }
        }
        case getActivePlanVendors:
        return {
            ...state,
            activePlanVendors: action.page === 1
            ? action.activePlanVendors ?? []
            : [...state.activePlanVendors, ...action.activePlanVendors ?? []],
            hasMoreVendor: action.hasMoreData,
            planVendorsLoaded: action.planVendorsLoaded,
            vendorListPage: action.page
        };

        case setActiveVendorsLoading:
            return{
                ...state,
                planVendorsLoaded: false
            }
        case getPlanRateStatus:
            return {
                ...state,
                planRateStatus: action.planRateStatus
            }
        case getCircuitTypes:
            return {
                ...state,
                planCircuitTypes: action.page === 1 ? action.planCircuitTypes ?? [] : [...state.planCircuitTypes, ...action.planCircuitTypes],
                hasMoreServiceData: action.hasMoreData,
                circuitPage: action.page,
                circuitListLoaded: action.isLoaded,
            }
        case setCircuitTypesLoading :
            return {
                ...state,
            circuitListLoaded: false
        }
        case addPlanComponentDetails:
            return {
                ...state,
                planComponents: {
                    ...state.planCatalogue,
                    dataTable: action.dataTable
                }
            }
        case getFinancePlanComponent:
            return {
                ...state,
                planComponents: action.planComponents
            }
        case resetPlanComponent:
            return {
                ...state,
                planComponents: {
                    ...state.planCatalogue,
                    dataTable: action.dataTable
                }
            }
        case deletePlanComponent:
            return {
                ...state,
                planComponents: {
                    ...state.planCatalogue,
                    dataTable: action.dataTable
                }
            }
        case updatePlanComponent:
            return {
                ...state,
                planComponents: {
                    ...state.planCatalogue,
                    dataTable: action.dataTable
                }
            }
        case fetchPlanDetails:
            return{
                ...state,
                planDetailsData: action.data
            };
        case setDefaultPlanCatalogue:
            return initialState;
        default:
            return state;
    }
};